import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/totalRevenueSalesSagas";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const PeriodType = () => {
  const dispatch = useDispatch();

  const periodTypeOptions = useSelector((state) => state.totalRevenueSales.periodTypeOptions);
  const selectedPeriodTypeOptions = useSelector(
    (state) => state.totalRevenueSales.selectedFilters.period_type
  );

  return (
    <MultiSelectDropdown
      options={periodTypeOptions}
      selectedFilters={selectedPeriodTypeOptions}
      includeFilter={false}
      onSelectChange={(data) => dispatch(actionCreators.updatePeriodType(data))}
    />
  );
};

export default PeriodType;
